import { render, staticRenderFns } from "./dashboardOrcamentoNaturezaDespesas.vue?vue&type=template&id=15e2894a&"
import script from "./dashboardOrcamentoNaturezaDespesas.vue?vue&type=script&lang=js&"
export * from "./dashboardOrcamentoNaturezaDespesas.vue?vue&type=script&lang=js&"
import style0 from "./dashboardOrcamentoNaturezaDespesas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports